import lodash from 'lodash';
import { IPredictWinV2Question, IPredictAndWinV2Contest, ICsvToJson, IWinners, IAnswersPawV2 } from '../model';

export const actionOptions = [
	{ label: 'Create', id: 'create' },
	{ label: 'Update', id: 'update' }
];

export const toInteger = (num: string) => {
	return parseInt(num, 10);
};

const INVALID_ANSWER: string = '-2';

function getTimeStampFromTimeString(timeString: string) {
	// sample time string "23/03/2024/09:30:00"
	const [day, month, year, time] = timeString.split('/');
	const [hour, minute, second] = time.split(':');
	const dateObject: Date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
	const istDateString: string = dateObject.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
	const istDateObject: Date = new Date(istDateString);
	return istDateObject.getTime();
}

export const preparePredictWinContest = (jsonData: ICsvToJson[]) => {
	const contestDetails: IPredictAndWinV2Contest = {};
	const questions: IPredictWinV2Question[] = [];
	const winners: IWinners[] = [];
	const answers: { [key: string]: string } = {};
	const answersPawV2: IAnswersPawV2 = {};
	const questionsValid: boolean[] = [];
	for (let i = 0; i < jsonData.length; i += 1) {
		const question: IPredictWinV2Question = {};
		if (i === 0) {
			contestDetails.contestId = jsonData[0].CONTEST_ID;
			contestDetails.team1 = jsonData[0].TEAM_1;
			contestDetails.team2 = jsonData[0].TEAM_2;
			contestDetails.flagTeam1 = jsonData[0].FLAG_TEAM_1;
			contestDetails.flagTeam2 = jsonData[0].FLAG_TEAM_2;
			contestDetails.contestImageUrl = jsonData[0].CONTEST_IMAGE_URL ? JSON.parse(jsonData[0].CONTEST_IMAGE_URL) : undefined;
			contestDetails.rewardHistoryImageUrl = jsonData[0].REWARD_HISTORY_IMAGE_URL
				? JSON.parse(jsonData[0].REWARD_HISTORY_IMAGE_URL)
				: undefined;
			contestDetails.resultDeclareTime = jsonData[0].RESULT_OUT_TIME
				? getTimeStampFromTimeString(jsonData[0].RESULT_OUT_TIME)
				: undefined;
			contestDetails.startTime = jsonData[0].START_TIME ? getTimeStampFromTimeString(jsonData[0].START_TIME) : undefined;
			contestDetails.endTime =
				jsonData[0].RESULT_OUT_TIME && jsonData[0].END_TIME_IN_MIN
					? contestDetails.resultDeclareTime + toInteger(jsonData[0].END_TIME_IN_MIN) * 60 * 1000
					: undefined;
			contestDetails.rewardExpiryTime =
				jsonData[0].RESULT_OUT_TIME && jsonData[0].REWARD_EXP_IN_MIN
					? contestDetails.resultDeclareTime + toInteger(jsonData[0].REWARD_EXP_IN_MIN) * 60 * 1000
					: undefined;
			contestDetails.contestShowTime = jsonData[0].CONTEST_SHOW_TIME
				? getTimeStampFromTimeString(jsonData[0].CONTEST_SHOW_TIME)
				: undefined;
			contestDetails.contestType = jsonData[0].CONTEST_TYPE ? jsonData[0].CONTEST_TYPE : undefined;
		}
		if (jsonData[i].QUESTION_TEXT) {
			question.id = String(i);
			question.text = JSON.parse(jsonData[i].QUESTION_TEXT);
			question.imageUrl = JSON.parse(jsonData[i].QUESTION_IMAGE_URL);
			question.startTime = getTimeStampFromTimeString(jsonData[i].START_TIME);
			question.endTime = question.startTime + toInteger(jsonData[i].DURATION_IN_MIN) * 60 * 1000;
			if (jsonData[i].REWARD) {
				question.rewards = JSON.parse(jsonData[i].REWARD);
			}
			let k = 1;
			const options = [];
			while (jsonData[i][`OPTION_TEXT_${k}`]) {
				options.push({
					id: String(k - 1),
					text: JSON.parse(jsonData[i][`OPTION_TEXT_${k}`])
				});
				k += 1;
			}
			question.options = options;
			questions.push(question);
		}
		if (jsonData[i].ANSWERS) {
			const key = String(i);
			if (Number(jsonData[i].ANSWERS) === -1) answers[key] = String(Number(jsonData[i].ANSWERS));
			else if (Number(jsonData[i].ANSWERS) > 0) answers[key] = String(Number(jsonData[i].ANSWERS) - 1);
			else answers[key] = INVALID_ANSWER;
		}
		if (jsonData[i].IS_QUESTION_VALID) {
			questionsValid.push(String(jsonData[i].IS_QUESTION_VALID).toLowerCase() === 'true');
			const questionId: string = String(i);
			answersPawV2[questionId] = [];
			let k: number = 1;
			while (jsonData[i][`OPTION_SCORE_${k}`]) {
				answersPawV2[questionId].push({
					optionId: String(k - 1),
					option_score: Number(jsonData[i][`OPTION_SCORE_${k}`])
				});
				k += 1;
			}
		}
		if (jsonData[i].WINNERS_NAME) {
			winners.push({
				name: jsonData[i].WINNERS_NAME,
				location: jsonData[i].WINNERS_LOCATION,
				zupeeUserId: Number(jsonData[i].ZUPEE_USER_ID)
			});
		}
	}
	if (!lodash.isEmpty(questions)) contestDetails.questions = questions;
	if (!lodash.isEmpty(answers)) contestDetails.answers = answers;
	if (!lodash.isEmpty(winners)) contestDetails.winners = winners;
	if (!lodash.isEmpty(answersPawV2)) contestDetails.answersPawV2 = answersPawV2;
	if (!lodash.isEmpty(questionsValid)) contestDetails.questionsValid = questionsValid;

	return contestDetails;
};
